function imageCarousel(){
    var $imageCar = [];
    if(jQuery('.block.block-carousel').length){
        jQuery('.block.block-carousel .swiper-container').each(function(i){
            $imageCar[i] = new Swiper(this, {
                slidesPerView: 1,
                loop: true,
                centeredSlides: true,
            });

            jQuery('.swiper-nav--next').click(function(){
                $imageCar[i].slideNext();
            });

            jQuery('.swiper-nav--prev').click(function(){
                $imageCar[i].slidePrev();
            });
        });
    }
}
